var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbvV16LiveStatCornerDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08312 13.6042C8.06228 16.3542 11.9581 16.3334 12.9581 13.6042L17.0623 15.5417C17.5623 15.8125 17.3331 16.5209 16.7915 16.4375C16.2498 16.3542 15.6664 15.8959 15.3123 15.7292C14.9581 15.5625 14.9998 15.5834 14.9164 15.5834C14.4164 15.8125 13.9373 16.1042 13.4373 16.3334C11.2498 17.2917 8.79145 17.2917 6.60395 16.3334C6.10395 16.1042 5.62478 15.8125 5.12478 15.5834L3.20812 16.4375C2.70812 16.4375 2.47895 15.8542 2.91645 15.5625L7.08312 13.5834V13.6042Z",
    fill: "#FB2C36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4795 7.22916V9.45832C10.167 9.39582 9.85449 9.39582 9.54199 9.45832V3.29166C9.54199 3.04166 9.93783 2.85416 10.1878 2.95832C10.667 3.14582 10.3753 3.70832 10.5212 3.95832L13.2503 6.72916C13.3753 6.83332 13.2295 7.20832 13.1253 7.20832H10.5003L10.4795 7.22916Z",
    fill: "#FB2C36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2503 14.7292C10.417 15.1667 9.47949 15.1459 8.66699 14.6667L9.25033 13.8542C9.31283 13.8126 10.417 13.8126 10.5628 13.8334C10.7087 13.8542 10.6462 13.8334 10.7087 13.8959C10.7712 13.9584 11.167 14.5209 11.2087 14.6042C11.2503 14.6876 11.2712 14.6876 11.2503 14.7292Z",
    fill: "#FFEB39"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4163 11.9167C12.6455 12.75 12.3955 13.6875 11.7705 14.2917L11.1246 13.4167C11.083 13.375 11.1038 13.3542 11.1246 13.3125C11.1663 13.0209 11.4163 12.6042 11.458 12.2709L12.4371 11.8959L12.4163 11.9167Z",
    fill: "#FFEB39"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20808 14.25C7.60392 13.6666 7.37475 12.7291 7.58308 11.9166L8.58308 12.3125L8.87475 13.25L8.20808 14.2708V14.25Z",
    fill: "#FFEB39"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 10.0834V11.1667L8.875 11.7292L7.8125 11.3125C8.20833 10.6459 8.89583 10.125 9.6875 10.0834Z",
    fill: "#FFEB39"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 10.0834C11.0833 10.125 11.8125 10.6667 12.1875 11.3334L11.125 11.7292L10.3333 11.1667V10.0834H10.3125Z",
    fill: "#FFEB39"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5003 13.2083H9.50033L9.22949 12.2708L9.97949 11.7291C10.0628 11.7291 10.7712 12.25 10.7712 12.3333L10.5003 13.2083Z",
    fill: "#FFEB39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbvV16LiveStatCornerDesktop);
export default __webpack_public_path__ + "static/media/kbv-v16-live-stat-corner-desktop.d0a5dd8206725b87360d59348a779746.svg";
export { ForwardRef as ReactComponent };